import parseHTML from '../utils/parseHTML';
import { serializeStyles, parseStyles, transformStyles, fontSizeTransformer } from '../utils/dom';
const stripThirdPartyClasses = node => {
  const classNames = node.getAttribute('class');
  if (typeof classNames !== 'string') {
    return;
  }
  const validClasses = classNames.split(' ').filter(className => className.includes('hs-'));
  if (validClasses.length === 0) {
    node.removeAttribute('class');
    return;
  }
  node.setAttribute('class', validClasses.join(' '));
};
const ListElements = ['OL', 'UL'];
function transformNode(node, formatTransformMap, clearAllStyles, defaultStylesMap, defaultAttributesMap) {
  let newNode = node;

  // Transform the node type
  if (formatTransformMap[node.nodeName]) {
    newNode = document.createElement(formatTransformMap[node.nodeName]);
    Array.from(node.childNodes).forEach(child => newNode.appendChild(child.cloneNode(true)));
    if (node.parentNode) {
      node.parentNode.replaceChild(newNode, node);
    }
  }

  // Clear node of all inline styles and classes
  if (clearAllStyles && newNode.style) {
    newNode.removeAttribute('style');
    stripThirdPartyClasses(newNode);
  }

  // Replace newlines with <br> in pre tags
  if (newNode.nodeName === 'PRE') {
    const html = newNode.innerHTML.replace(/\r?\n/g, '<br />');
    newNode.innerHTML = html;
  }
  if (newNode.nodeName !== '#text') {
    const styleAttribute = newNode && typeof newNode.getAttribute === 'function' ? newNode.getAttribute('style') || '' : '';
    // Transform styles
    let stylesMap = transformStyles(parseStyles(styleAttribute), fontSizeTransformer);

    // Add default styles of node
    if (defaultStylesMap[newNode.nodeName]) {
      // Set default styles if nothing is set already
      stylesMap = Object.assign({}, defaultStylesMap[newNode.nodeName], stylesMap);
    }
    const serializedStyles = serializeStyles(stylesMap);
    if (serializedStyles) {
      newNode.setAttribute('style', serializedStyles);
    }
  }

  // Move list element inside the previous sibling 'LI' because tinymce core
  // filters out list elements at the top level when already within a list, see
  // https://github.com/tinymce/tinymce/blob/f0ccec8759fb24a0fb78bb0881d828430459c422/modules/tinymce/src/core/main/ts/content/InsertList.ts#L182
  if (ListElements.includes(newNode.nodeName)) {
    if (newNode.previousElementSibling && newNode.previousElementSibling.nodeName === 'LI' && newNode.parentNode && ListElements.includes(newNode.parentNode.nodeName)) {
      newNode.previousElementSibling.appendChild(newNode);
    }
  }
  const defaultAttrs = defaultAttributesMap[newNode.nodeName];
  if (defaultAttrs) {
    Object.keys(defaultAttrs).forEach(attr => {
      newNode.setAttribute(attr, defaultAttrs[attr]);
    });
  }
  Array.from(newNode.childNodes).forEach(child => transformNode(child, formatTransformMap, clearAllStyles, defaultStylesMap, defaultAttributesMap));
  return newNode;
}
export const getGenericPasteProcessingConverter = (formatTransformMap = {}, clearAllStyles = false, defaultStylesMap = {}, defaultAttributesMap = {}) => html => {
  if (Object.keys(formatTransformMap).length || clearAllStyles || Object.keys(defaultStylesMap).length || Object.keys(defaultAttributesMap).length) {
    const doc = parseHTML(html);
    Array.from(doc.childNodes).forEach(node => transformNode(node, formatTransformMap, clearAllStyles, defaultStylesMap, defaultAttributesMap));
    return doc.outerHTML;
  }
  return html;
};